export default {
  callLogs: 'Call logs',
  emptyCallLogs: 'No call logs found.',
};
